import React from "react";
import { Button } from "src/components";
import { ModalManager, Modal } from "src/components/Modal";
import { useTranslation } from "src/hooks/useTranslation";
import styled from "styled-components";
import KtpGuideCorrect from "./assets/ktp_guide_correct.svg";
import KtpGuideBlurry from "./assets/ktp_guide_blurry.svg";
import KtpGuideTilted from "./assets/ktp_guide_tilted.svg";

const KtpGuideEl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  max-width: 606px;
  padding: 40px;
  font-family: ${(props) => props.theme.text.fontFamily.normal};
`;

const KtpGuideTitleEl = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: 0.015em;
  color: #2d2e34;
`;

const KtpGuideListEl = styled.ol`
  margin: 0;
  padding-left: 1.5em;
  list-style: decimal;
  font-size: 16px;
  line-height: 26px;
  color: #4f515c;
`;

const KtpGuideImagesEl = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;

  > img {
    width: 147.5px;
    height: 147.5px;
    border-radius: 12px;
  }
`;

type Props = {
  show: boolean;
  onClose: () => any;
};

export const KtpScanGuideModal = ({ show, onClose }: Props) => {
  const translate = useTranslation() as any;
  const path = "owner_info.ktp_scan.guide";

  return (
    <ModalManager showModal={show} onClose={onClose}>
      <Modal
        fitWidth
        style={{
          height: "auto",
          borderRadius: 16,
          boxShadow: "0px 4px 20px rgba(30, 44, 106, 0.1)",
        }}
      >
        <KtpGuideEl>
          <KtpGuideTitleEl>{translate(`${path}.title`)}</KtpGuideTitleEl>
          <KtpGuideListEl>
            {translate(`${path}.points`).map((point: string) => (
              <li key={point}>{point}</li>
            ))}
          </KtpGuideListEl>
          <KtpGuideImagesEl>
            <img src={KtpGuideCorrect} alt="correct KTP example" />
            <img src={KtpGuideBlurry} alt="blurry KTP example" />
            <img src={KtpGuideTilted} alt="tilted KTP example" />
          </KtpGuideImagesEl>
          <Button onClick={onClose} style={{ padding: "0 24px" }}>
            {translate(`${path}.cta`)}
          </Button>
        </KtpGuideEl>
      </Modal>
    </ModalManager>
  );
};
